export enum Messages {
  NO_RESULTS = 'No results',
  LOADING = 'Loading...'
}
